import createTemplate from './createTemplate';
import getTemplates from './getTemplates';
import editTemplate from './editTemplate';
import deleteTemplate from './deleteTemplate';

export default {
  createTemplate,
  getTemplates,
  editTemplate,
  deleteTemplate
}



// WEBPACK FOOTER //
// ./src/app/services/message-template/index.js